import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpClientModule, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError, map, tap } from 'rxjs/operators';
import { Errors } from '../../../infrastructure/labels/errors';
import { ToastService } from '../../../services/core/toast/toast.service';

import { Router } from '@angular/router';
import { ErrorTranslations } from 'src/infrastructure/error/errorTranslations';
import { ToastrService } from 'ngx-toastr';
import { LocalstorageService } from 'src/services/core/localstorage/localstorage.service';

interface ErrorDetails {
  msg: string,
  redirect: string
}

@Injectable({
  providedIn: 'root'
})
export class ErrorinterceptorService implements HttpInterceptor {

  constructor(
    private toastService: ToastService,
    private router: Router,
    private localStorageService: LocalstorageService) 
    { };

    
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      retry(1),
      catchError((error: HttpErrorResponse) => {
        if (error) {
          var language = 'bg';
          const status =  error.status.toString();
          if (Errors.statuses[status as keyof typeof Errors.statuses]) {
            Errors.statuses[status as keyof typeof Errors.statuses](error, this.toastService, this.router, language, this.localStorageService);
          }
          else {
            Errors.statuses.default(error, this.toastService, this.router, language);

          }
        }
        return throwError(error);
      })
    )}
}